function Hover({ points, height, width }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='100%'
      width='100%'
      viewBox={`0 0 ${width} ${height}`}
      className='sc-eKszNL gPukXk'
    >
      <mask id='polygonMask-1611011b-d6ab-4ac8-bf52-afeaf23a8620' maskUnits='userSpaceOnUse'>
        <rect x='0' y='0' fill='#FFF' width='100%' height='100%' />
        <polygon points={points} strokeWidth='0.3' stroke='#FFF' fill='#000' />
      </mask>
      <g>
        <polygon
          points={points}
          stroke='#0b7dda'
          fill='transparent'
          strokeWidth='4'
          mask='url(#polygonMask-1611011b-d6ab-4ac8-bf52-afeaf23a8620)'
        />
      </g>
    </svg>
  );
}

// "384.22,252.61 384.22,267.11 79.21,267.11 79.21,281.61 498,281.61 498,267.11 522.53,267.11 522.53,252.61"
// "384.22,252.61 384.22,267.11 79.21,267.11 79.21,281.61 498,281.61 498,267.11 522.53,267.11 522.53,252.61"

export default Hover;
